import React from "react";

// Iron House Design System — Card (copiado do DS oficial, + import React).
export function Card(props) {
  const {
    children,
    variant = "light",
    padding = "md",
    image,
    imageAlt = "",
    imageHeight = 180,
    onClick,
    className = "",
    ...rest
  } = props;

  const [hovered, setHovered] = React.useState(false);

  const paddingMap = {
    sm: "var(--space-4)",
    md: "var(--space-6)",
    lg: "var(--space-8)",
    none: "0",
  };

  const variantMap = {
    light: { background: "var(--color-white)", color: "var(--text-primary)", border: "1px solid var(--border-default)" },
    dark: { background: "var(--color-black)", color: "var(--text-on-dark)", border: "1px solid var(--border-on-dark)" },
    iron: { background: "var(--color-iron)", color: "var(--text-on-dark)", border: "none" },
    elevated: { background: "var(--color-white)", color: "var(--text-primary)", border: "none", boxShadow: "var(--shadow-md)" },
  };

  const cardStyle = {
    borderRadius: "var(--radius-md)",
    overflow: "hidden",
    transition: `all var(--duration-normal) var(--ease-default)`,
    cursor: onClick ? "pointer" : "default",
    transform: hovered && onClick ? "translateY(-2px)" : "none",
    boxShadow: hovered && onClick ? "var(--shadow-lg)" : variantMap[variant].boxShadow || "none",
    ...variantMap[variant],
  };

  return (
    <div
      style={cardStyle}
      className={className}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...rest}
    >
      {image ? (
        <img
          src={image}
          alt={imageAlt}
          style={{ width: "100%", height: imageHeight + "px", objectFit: "cover", display: "block" }}
        />
      ) : null}
      <div style={{ padding: paddingMap[padding] }}>{children}</div>
    </div>
  );
}

export default Card;
